import React, { useEffect, useState, useMemo } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import PropTypes from "prop-types";

import * as brandActions from "src/redux/actions/brand.action";
import * as departmentActions from "src/redux/actions/department.action";
import * as yearActions from "src/redux/actions/year.action";
import * as reportfinalbydeptsActions from "src/redux/actions/reportfinalbydepts.action";
import * as budgetsActions from "src/redux/actions/budgets.action";
import * as approvebudgetActions from "src/redux/actions/approvebudget.action";
import * as updateapprovebudgetActions from "src/redux/actions/updateapprovebudget.action";
import * as rejectapprovebudgetActions from "src/redux/actions/rejectapprovebudget.action";
import * as approvebudgethistoryActions from "src/redux/actions/approvebudgethistory.action";
import * as reportbudgetdetailActions from "src/redux/actions/reportbudgetdetail.action";
import * as getbudgetcomparebydeptsActions from "src/redux/actions/getbudgetcomparebydepts.action";
import * as getbudgetcomparebydeptdActions from "src/redux/actions/getbudgetcomparebydeptd.action";

import { useParams } from "react-router-dom";
import {
  AppBar,
  Tabs,
  Tab,
  TextField,
  Grid,
  Typography,
  makeStyles,
  Button,
  Icon,
  Modal,
  Backdrop,
  Fade,
  Card,
  CardActions,
  CardContent,
  MenuItem,
  Paper,
  Box,
  ButtonGroup,
  Container,
  CardHeader,
  Divider,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Formik, Form, Field } from "formik";

import { TextField as TextFieldFormik } from "formik-material-ui";
import CustomDialog from "src/components/fragments/CustomDialog";
import PopupDialog from "src/components/fragments/PopupDialog";
import Page from "src/components/Page";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    // flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
    // marginTop: theme.spacing.unit * 3,
    // overflowX: "auto",
    // "& .MuiTextField-root": {
    //   margin: theme.spacing(1),
    //   // width: "10ch",
    // },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  iconbtnreject: {
    color: "secondary",
  },
}));

export default function ManagerReportDetailByBrand() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [brandId, setBrandId] = useState(0);
  const [deptId, setDeptId] = useState(0);
  const [yearId, setYearId] = useState(0);
  const [yearCode, setyearCode] = useState(0);
  const [yearLock, setYearLock] = useState(null);
  const [budgetsid, setBudgetsid] = useState(null);
  const [openPopupDlg, setOpenPopupDlg] = useState(false);
  const [openPopupDlgWarn, setOpenPopupDlgWarn] = useState(false);

  const [openDlgconfirm, setopenDlgconfirm] = useState(false);

  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(
    ({ budgetsReducer }) => budgetsReducer,
    shallowEqual
  );
  const brandReducer = useSelector(({ brandReducer }) => brandReducer);
  const departmentReducer = useSelector((state) => state.departmentReducer);
  const loginReducer = useSelector((state) => state.loginReducer);
  const getbudgetcomparebydeptsReducer = useSelector(
    (state) => state.getbudgetcomparebydeptsReducer
  );
  const getbudgetcomparebydeptdReducer = useSelector(
    (state) => state.getbudgetcomparebydeptdReducer
  );
  const reportbudgetdetailReducer = useSelector(
    (state) => state.reportbudgetdetailReducer
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const clearDataDropDown = () => {
    dispatch(getbudgetcomparebydeptsActions.clearBudgetCompSD());
    dispatch(getbudgetcomparebydeptdActions.clearBudgetCompDD());

    dispatch(
      departmentActions.getDepts(loginReducer.result.countryid, 0, 0, 0)
    );
    setValue(0);
  };

  const handleChangeBrand = (e) => {
    const data = e.target.value;
    clearDataDropDown();
    setValue(0);
    setBrandId(data);
  };

  const handlePopupDlgWarn = (value) => {
    if (value) {
      setOpenPopupDlgWarn(false);
    }
  };

  const renderDepts = (e) => {
    dispatch(
      departmentActions.getDepts(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid,
        brandId
      )
    )
      .then((result) => {
        setTimeout(() => {
          if (result) {
          } else {
          }
        }, 1000);
      })
      .catch((result) => {});
  };

  const handleChangeYear = (e) => {
    const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = JSON.parse(e.target.value);
    clearDataDropDown();
    // setValue(0);
    if (BUDGETH_ID !== undefined) {
      setYearId(BUDGETH_ID);
    } else {
      setYearId(0);
    }
    // renderDepts();
    setyearCode(YEAR_CODE);
    setYearLock(BUDGETH_LOCK);
  };

  // const handleConfirmDlg = (value, data) => {
  //   if (value) {
  //     dispatch(reportfinalbybrandActions.reportFinalByBrand(data));
  //     setOpenPopupDlg(true);
  //   }
  //   setopenDlgconfirm(false);
  // };

  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch(
        brandActions.getBrands(
          loginReducer.result.countryid,
          loginReducer.result.companyid,
          loginReducer.result.secureid
        )
      );
      dispatch(
        yearActions.getYear(
          loginReducer.result.countryid +
            loginReducer.result.companyid +
            brandId +
            yearId
        )
      );

      return () => {
        clearDataDropDown();
        // dispatch(reportbudgetdetailActions.clearreportBudgetsDetail());
      };
    },
    []
    // [countryid, companyid, brandId, deptId, yearId]
  );
  return (
    <Page className={classes.root} title="Comparison Report by department">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For the budget module on the system."
            title="Comparison Report by department"
          />
          <Divider />
          <CardContent>
            {/* <Alert icon={false} variant="outlined" severity="error">
        <Typography variant="h4">
          Budget Compare Report by Department
        </Typography>
      </Alert> */}

            <form
              onSubmit={(e) => {
                e.preventDefault();
                renderDepts();
              }}
            >
              <Grid container xs={12}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  flex={1}
                  style={{ lineHeight: 5 }}
                >
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeBrand}
                    id="brand"
                    label="Brand"
                    // autoComplete="investmenttype"
                    autoFocus
                    style={{ width: "20%", minWidth: "10%" }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={0}
                  >
                    <option key={0} value={0} selected>
                      -
                    </option>
                    {brandReducer.result &&
                      brandReducer.result.map((item) => (
                        <option
                          key={item.ORG_BRAND_ID}
                          value={item.ORG_BRAND_ID}
                        >
                          {item.BRAND}
                        </option>
                      ))}
                  </TextField>

                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeYear}
                    label="Year"
                    style={{ width: "10%", marginLeft: 10 }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={0}
                  >
                    <option key={0} value={0} selected>
                      -
                    </option>
                    {yearReducer.result &&
                      yearReducer.result.map((item) => (
                        // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                        <option
                          key={item.YEAR_CODE}
                          value={JSON.stringify(item)}
                        >
                          {/* {item.YEAR_CODE} */}
                          {item.YEAR_SEQ_T}
                        </option>
                      ))}
                  </TextField>

                  <Box style={{ marginLeft: 10 }}>
                    <Button
                      // variant="outlined"
                      variant="contained"
                      color="default"
                      type="submit"
                    >
                      <Icon>search</Icon> Search
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </form>

            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant="fullWidth"
                centered
              >
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="-  Choose Department  -"
                  {...a11yProps(0)}
                />
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Budget Compare : Summary"
                  {...a11yProps(1)}
                />
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Budget Compare : Detail"
                  {...a11yProps(2)}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <Grid container spacing={2}>
                <Paper className={classes.root}>
                  <MaterialTable
                    title="Report by Department"
                    // isLoading={approvebudgetReducer.isFetching}
                    on
                    columns={[
                      {
                        title: "ORG_CODE",
                        field: "ORG_DEPARTMENT_ID",
                        hidden: true,
                      },
                      {
                        title: "Code",
                        field: "DEPARTMENT_CODE",
                        width: 80,
                      },
                      {
                        title: "Group",
                        field: "DEPARTMENT_GROUP",
                        width: 80,
                      },
                      {
                        title: "Department",
                        field: "department",
                      },
                    ]}
                    data={
                      departmentReducer.result ? departmentReducer.result : []
                    }
                    actions={[
                      {
                        tooltip: "Process report data",
                        icon: "table_chart",
                        iconProps: {
                          style: {
                            fontSize: "50px",
                            color: "#5c9aff",
                            captionSide: "bottom",
                          },
                        },
                        onClick: (e, rowData) => {
                          if (brandId !== 0 && yearId !== 0) {
                            let data = {};
                            data.department = rowData;
                            setValue(1);
                            dispatch(
                              getbudgetcomparebydeptsActions.getBudgetCompSD(
                                loginReducer.result.countryid,
                                loginReducer.result.companyid,
                                brandId,
                                yearId,
                                data
                              )
                            )
                              .then((result) => {
                                dispatch(
                                  getbudgetcomparebydeptdActions.getBudgetCompDD(
                                    loginReducer.result.countryid,
                                    loginReducer.result.companyid,
                                    brandId,
                                    yearId,
                                    data
                                  )
                                );
                              })
                              .catch((result) => {
                                // Error Message
                              });
                          } else {
                            setOpenPopupDlgWarn(true);
                          }
                        },
                      },
                    ]}
                    options={{
                      selection: true,
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      showTitle: false,
                      // searchFieldAlignment: "left",
                      // toolbarButtonAlignment: "left",
                      pageSize: 10,
                      pageSizeOptions: [10, 50, 100],
                      paging: true,
                    }}
                  />
                </Paper>
              </Grid>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MaterialTable
                    title="Budget Compare Report Summary by Department"
                    on
                    isLoading={getbudgetcomparebydeptsReducer.isFetching}
                    data={
                      getbudgetcomparebydeptsReducer.result
                        ? getbudgetcomparebydeptsReducer.result
                        : []
                    }
                    columns={[
                      { title: "Budget Code", field: "ACC_CODE" },
                      { title: "Budget Name", field: "ACC_NAME" },
                      { title: "Category", field: "ACC_CATEGORY_NM" },
                      { title: "Group", field: "ACC_GROUP2" },
                      {
                        title: "Total Budget.",
                        editable: "never",
                        type: "numeric",
                        field: "TOT_BUDGET",
                        render: (rowData) => {
                          if (rowData.TOT_BUDGET) {
                            return rowData.TOT_BUDGET.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Total Forecast.",
                        editable: "never",
                        type: "numeric",
                        field: "TOTAL_FORECAST",
                        render: (rowData) => {
                          if (rowData.TOTAL_FORECAST) {
                            return rowData.TOTAL_FORECAST.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Total Actual.",
                        editable: "never",
                        type: "numeric",
                        field: "TOTAL_ACTUAL",
                        render: (rowData) => {
                          if (rowData.TOTAL_ACTUAL) {
                            return rowData.TOTAL_ACTUAL.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },

                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M1",
                        field: "B_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M1) {
                            return rowData.B_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M1",
                        field: "F_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M1) {
                            return rowData.F_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M1",
                        field: "A_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M1) {
                            return rowData.A_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M2",
                        field: "B_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M2) {
                            return rowData.B_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M2",
                        field: "F_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M2) {
                            return rowData.F_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M2",
                        field: "A_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M2) {
                            return rowData.A_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M3",
                        field: "B_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M3) {
                            return rowData.B_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M3",
                        field: "F_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M3) {
                            return rowData.F_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M3",
                        field: "A_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M3) {
                            return rowData.A_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M4",
                        field: "B_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M4) {
                            return rowData.B_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M4",
                        field: "F_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M4) {
                            return rowData.F_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M4",
                        field: "A_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M4) {
                            return rowData.A_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M5",
                        field: "B_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M5) {
                            return rowData.B_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M5",
                        field: "F_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M5) {
                            return rowData.F_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M5",
                        field: "A_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M5) {
                            return rowData.A_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M6",
                        field: "B_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M6) {
                            return rowData.B_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M6",
                        field: "F_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M6) {
                            return rowData.F_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M6",
                        field: "A_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M6) {
                            return rowData.A_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M7",
                        field: "B_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M7) {
                            return rowData.B_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M7",
                        field: "F_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M7) {
                            return rowData.F_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M7",
                        field: "A_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M7) {
                            return rowData.A_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M8",
                        field: "B_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M8) {
                            return rowData.B_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M8",
                        field: "F_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M8) {
                            return rowData.F_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M8",
                        field: "A_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M8) {
                            return rowData.A_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M9",
                        field: "B_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M9) {
                            return rowData.B_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M9",
                        field: "F_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M9) {
                            return rowData.F_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M9",
                        field: "A_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M9) {
                            return rowData.A_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M10",
                        field: "B_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M10) {
                            return rowData.B_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M10",
                        field: "F_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M10) {
                            return rowData.F_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M10",
                        field: "A_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M10) {
                            return rowData.A_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M11",
                        field: "B_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M11) {
                            return rowData.B_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M11",
                        field: "F_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M11) {
                            return rowData.F_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M11",
                        field: "A_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M11) {
                            return rowData.A_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M12",
                        field: "B_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M12) {
                            return rowData.B_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M12",
                        field: "F_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M12) {
                            return rowData.F_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M12",
                        field: "A_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M12) {
                            return rowData.A_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      {
                        title: "Detail",
                        field: "accdetail",
                        type: "string",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },
                    ]}
                    options={{
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      showTitle: false,
                      searchFieldAlignment: "left",
                      exportButton: true,
                      toolbarButtonAlignment: "left",
                      exportAllData: true,
                      // actionsColumnIndex: -1,
                      pageSize: 10,
                      pageSizeOptions: [10, 50, 100],
                      // paging: true,
                    }}
                  />
                </Grid>
              </Grid>
              <br />
            </TabPanel>

            <TabPanel value={value} index={2}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MaterialTable
                    title="Budget Compare Report Detail by Department"
                    on
                    isLoading={getbudgetcomparebydeptdReducer.isFetching}
                    data={
                      getbudgetcomparebydeptdReducer.result
                        ? getbudgetcomparebydeptdReducer.result
                        : []
                    }
                    columns={[
                      { title: "Brand Code", field: "BRAND_CODE" },
                      { title: "Brand Name", field: "Brand" },
                      { title: "Department Code", field: "DEPARTMENT_CODE" },
                      { title: "Department Name", field: "Department" },
                      { title: "Budget Code", field: "ACC_CODE" },
                      { title: "Budget Name", field: "ACC_NAME" },
                      { title: "Category", field: "ACC_CATEGORY_NM" },
                      { title: "Group", field: "ACC_GROUP2" },
                      {
                        title: "Total Budget.",
                        editable: "never",
                        type: "numeric",
                        field: "TOT_BUDGET",
                        render: (rowData) => {
                          if (rowData.TOT_BUDGET) {
                            return rowData.TOT_BUDGET.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Total Forecast.",
                        editable: "never",
                        type: "numeric",
                        field: "TOTAL_FORECAST",
                        render: (rowData) => {
                          if (rowData.TOTAL_FORECAST) {
                            return rowData.TOTAL_FORECAST.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Total Actual.",
                        editable: "never",
                        type: "numeric",
                        field: "TOTAL_ACTUAL",
                        render: (rowData) => {
                          if (rowData.TOTAL_ACTUAL) {
                            return rowData.TOTAL_ACTUAL.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },

                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M1",
                        field: "B_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M1) {
                            return rowData.B_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M1",
                        field: "F_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M1) {
                            return rowData.F_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M1",
                        field: "A_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M1) {
                            return rowData.A_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M2",
                        field: "B_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M2) {
                            return rowData.B_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M2",
                        field: "F_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M2) {
                            return rowData.F_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M2",
                        field: "A_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M2) {
                            return rowData.A_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M3",
                        field: "B_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M3) {
                            return rowData.B_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M3",
                        field: "F_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M3) {
                            return rowData.F_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M3",
                        field: "A_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M3) {
                            return rowData.A_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M4",
                        field: "B_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M4) {
                            return rowData.B_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M4",
                        field: "F_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M4) {
                            return rowData.F_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M4",
                        field: "A_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M4) {
                            return rowData.A_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M5",
                        field: "B_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M5) {
                            return rowData.B_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M5",
                        field: "F_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M5) {
                            return rowData.F_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M5",
                        field: "A_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M5) {
                            return rowData.A_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M6",
                        field: "B_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M6) {
                            return rowData.B_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M6",
                        field: "F_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M6) {
                            return rowData.F_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M6",
                        field: "A_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M6) {
                            return rowData.A_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M7",
                        field: "B_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M7) {
                            return rowData.B_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M7",
                        field: "F_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M7) {
                            return rowData.F_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M7",
                        field: "A_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M7) {
                            return rowData.A_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M8",
                        field: "B_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M8) {
                            return rowData.B_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M8",
                        field: "F_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M8) {
                            return rowData.F_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M8",
                        field: "A_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M8) {
                            return rowData.A_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M9",
                        field: "B_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M9) {
                            return rowData.B_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M9",
                        field: "F_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M9) {
                            return rowData.F_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M9",
                        field: "A_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M9) {
                            return rowData.A_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M10",
                        field: "B_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M10) {
                            return rowData.B_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M10",
                        field: "F_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M10) {
                            return rowData.F_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M10",
                        field: "A_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M10) {
                            return rowData.A_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M11",
                        field: "B_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M11) {
                            return rowData.B_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M11",
                        field: "F_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M11) {
                            return rowData.F_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M11",
                        field: "A_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M11) {
                            return rowData.A_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      //// 1 Set----------------------------------------------------
                      {
                        title: "Budget M12",
                        field: "B_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.B_M12) {
                            return rowData.B_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Forecast M12",
                        field: "F_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.F_M12) {
                            return rowData.F_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Actual M12",
                        field: "A_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.A_M12) {
                            return rowData.A_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      ////------------------------------------ 1 Set
                      {
                        title: "Detail",
                        field: "accdetail",
                        type: "string",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },
                    ]}
                    options={{
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      showTitle: false,
                      searchFieldAlignment: "left",
                      exportButton: true,
                      toolbarButtonAlignment: "left",
                      exportAllData: true,
                      // actionsColumnIndex: -1,
                      pageSize: 10,
                      pageSizeOptions: [10, 50, 100],
                      // paging: true,
                    }}
                  />
                </Grid>
              </Grid>
              <br />
            </TabPanel>
          </CardContent>
          <PopupDialog
            title="Information Message : Budget Compare Report By Department"
            message={<Alert severity="warning">Please choose year.</Alert>}
            open={openPopupDlgWarn}
            onClose={handlePopupDlgWarn}
          />
        </Card>
      </Container>
    </Page>
  );
}
